<core-dialog
  (closeDialogEvent)="closeModal(false)"
  (saveDialogEvent)="onSave()"
  [dialogTitle]="dialogTitle"
  [dialogSubtitle]="dialogSubtitle"
  [confirmButtonText]="dialogConfirmButtonText"
  [closeButtonText]="dialogCancelButtonText"
>
</core-dialog>
